import ListingEmptyBuildingsSvg from '@assets/images/svg/listing-empty-buildings.svg';
import React from 'react';
import { View } from 'react-native';

export interface ListingEmptyBuildingsIconProps {
  width?: number;
  height?: number;
}

/** Figma empty-listing illustration (buildings + clouds). Intrinsic 225×167. */
export function ListingEmptyBuildingsIcon({
  width = 225,
  height = 167,
}: Readonly<ListingEmptyBuildingsIconProps>) {
  return (
    <View
      style={{
        width,
        height,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <ListingEmptyBuildingsSvg width={width} height={height} />
    </View>
  );
}

export default ListingEmptyBuildingsIcon;
